import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';
import { collapsibleModals } from './consts.js';
import CollapsibleListSettingsModal from './modals/SettingsModals.js';
import { findParentNodeClosestToPos } from './tiptap/utils.js';
import '@tiptap/pm/state';
import 'ricos-types';
import 'classnames';
import 'lodash';
import 'react';
import 'ricos-context';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './components/modal-components/CollapsibleListSettings.js';
import 'wix-rich-content-plugin-commons';
import './dataHooks.js';
import './types.js';

const getToolbarButtons = (config, services) => {
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        Component: CollapsibleListSettingsModal,
        id: collapsibleModals.settings
      },
      command: ({ isMobile, attributes: { selectedNode } }) => {
        const componentProps = {
          nodeId: selectedNode.attrs.id,
          isQapageDataEnabled: !!(config == null ? void 0 : config.isQapageData)
        };
        services.modals.openModal(collapsibleModals.settings, {
          componentProps,
          positioning: { placement: "right" },
          layout: isMobile ? "fullscreen" : "drawer"
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      attributes: {
        selectedNode: selectedNodeResolver
      }
    }
  ];
};
const selectedNodeResolver = {
  id: "selectedNode",
  resolve: (_, __, editor) => {
    var _a;
    const { selection } = (editor == null ? void 0 : editor.state) || {};
    const node = (_a = findParentNodeClosestToPos(
      selection.$to,
      (node2) => {
        var _a2;
        return ((_a2 = node2 == null ? void 0 : node2.type) == null ? void 0 : _a2.name) === TIPTAP_COLLAPSIBLE_LIST_TYPE;
      }
    )) == null ? void 0 : _a.node;
    if (node) {
      return node;
    } else {
      return void 0;
    }
  }
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
